import { call } from 'redux-saga/effects';

import { getPublishedConnectionColumnInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause, MixedContentItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnectionColumns } from '~src/publishedConnectionTable/resources/PublishedConnectionColumns';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { PublishedConnectionColumnContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const PublishedConnectionColumnDefinition: MixedContentItemDefinition = {
  itemType: 'publishedConnectionColumn',
  pluralName: Messages.publishedConnectionColumns,
  singularName: Messages.publishedConnectionColumn,
  emptyStateMessage: Messages.publishedConnectionColumnsEmpty,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnections,
  contentFilterKeys: PublishedConnectionColumnContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: null,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['publishedConnectionColumn']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return PublishedConnectionColumns.all().withExtraParams(PublishedConnectionColumnContentType.extraQueryParams);
  },
  fieldValueResourceType: 'publishedConnectionColumn',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionColumnInfos, contentList),
  supportedDisplayModes: ['list'],
};
